<template>
  <el-main class="userdetail">
    <div class="mybread">
      <p>
        <i class="el-icon-location"></i>当前位置：
      </p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>客户项目</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/project' }">项目列表</el-breadcrumb-item>
        <el-breadcrumb-item>项目详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="header">
      <div class="header-info">
        <h1>{{ `${projectArr.brand} -${projectArr.contract_name}` }}</h1>
        <p style="font-size: 20px; font-weight: 550;">{{ projectArr.manager_name }} {{ projectArr.manager_enname }}</p>
        <p v-if="projectArr.project_start_time != '0000-00-00'">
          项目时间: {{
            `${projectArr.project_start_time}-${projectArr.project_end_time}` }}
        </p>
        <p v-if="projectArr.finish_time != '0000-00-00'">项目完成时间：{{ projectArr.finish_time }}</p>
      </div>
      <div class="header-status">
        <div style="margin-right: 10px;">
          <el-button round style="text-align: center;" @click="handoverShow = true"
            v-if="NodeInclude('35')">项目交接</el-button>
        </div>
        <div style="margin-right: 10px;">
          <el-button round style="text-align: center;" @click="statusShow = true"
            v-if="NodeInclude('34')">更新项目状态</el-button>
        </div>
        <div v-if="projectArr.status">
          <div class="button" :style="{ 'backgroundColor': dd.pro_status_c[projectArr.status].color }">{{
            dd.pro_status_c[projectArr.status].word }}</div>
        </div>
      </div>
    </div>
    <!-- 客户信息 -->
    <div class="base1">
      <h3 class="ntitle">客户信息</h3>
      <ul>
        <li>
          <p>
            <label>客户公司名称：</label>
            <a>{{ projectArr.client_company }}</a>
          </p>
          <p>
            <label>联系人姓名：</label>
            <a>{{ projectArr.name }}</a>
          </p>
          <p>
            <label>联系人邮箱：</label>
            <a>{{ projectArr.email }}</a>
          </p>
        </li>
        <li>
          <p>
            <label>品牌：</label>
            <a>{{ projectArr.brand }}</a>
          </p>
          <p>
            <label>联系人电话：</label>
            <a>{{ projectArr.phone }}</a>
          </p>
        </li>
      </ul>
      <ul>
        <li>
          <p>
            <label>付款账户：</label>
            <a>{{ projectArr.pay_company }}</a>
          </p>
          <p>
            <label>银行账号：</label>
            <a class="hoverlink" @click="clickCopy(projectArr.pay_bank_account)">
              {{
                projectArr.pay_bank_account }}
            </a>
          </p>
        </li>
        <li>
          <p>
            <label>银行名称：</label>
            <a>{{ projectArr.pay_bank }}</a>
          </p>
        </li>
      </ul>
      <ul>
        <li>
          <p>
            <label>统一社会信用代码：</label>
            <a>{{ projectArr.company_id_card }}</a>
          </p>
          <p>
            <label>公司电话：</label>
            <a>{{ projectArr.company_phone }}</a>
          </p>
        </li>
        <li>
          <p>
            <label>公司注册地址：</label>
            <a>{{ projectArr.reg_address }}</a>
          </p>
        </li>
      </ul>
    </div>
    <!-- 合同信息 -->
    <div class="base1">
      <h3 class="ntitle">合同信息</h3>
      <div class="operater" v-if="projectArr.contract_start_time != '0000-00-00'">
        <div class="linkline" @click="fillContract"
          v-if="((!projectArr.contract_no || projectArr.contract_no == 'TBD') && NodeInclude('37') && projectArr.is_white != '1') || level == '1'">
          编辑</div>
        <div class="linkbox" @click="contractApply" :class="{ 'grey': (is_apply != 1 && is_apply != 3)}"
          v-if="NodeInclude('343') && projectArr.is_white != '1'">
          {{ fileList1[0].origin_name ? '已签约' : (projectArr.contract_no && projectArr.contract_no != 'TBD' ? '已立项' :
            ((is_apply == 1 || is_apply == 3) ? '合同申请' : '等待编号')) }}
        </div>
      </div>
      <template
        v-if="projectArr.contract_start_time == '0000-00-00' && NodeInclude('37') && projectArr.is_white != '1'">
        <div class="inblank">
          <el-button class="ibtn" icon="el-icon-plus" circle @click="fillContract"></el-button>
          <p>该项目暂无合同信息，点击创建</p>
        </div>
      </template>
      <template v-else>
        <ul style="margin-bottom: 20px;">
          <li>
            <p>
              <label>合同编号：</label>
              <a style="width: 100%;">
                <el-col :span="10">{{ projectArr.contract_no ? projectArr.contract_no : '暂无合同编号' }}</el-col>
                <div class="projectArrBtnArea">
                  <div class="projectArrBtn" v-if="projectArr.status != '5'">
                    <el-button round style="text-align: center;" @click="getProjectNo" :disabled="!canGetNo"
                      v-if="NodeInclude('38') && projectArr.is_white != '1'">自动获取</el-button>
                  </div>
                  <!-- <div class="projectArrBtn" v-if="projectArr.status != '5' && is_apply == 2 && (projectArr.contract_no && projectArr.contract_no != 'TBD')">
                    <el-button round type="warning" style="text-align: center;" @click="handleConApply(3)" :disabled="!canGetNo"
                      v-if="NodeInclude('38') && projectArr.is_white != '1'">退回申请</el-button>
                  </div> -->
                </div>
              </a>
            </p>
            <p>
              <label>合同类型：</label>
              <a>{{ dd.contract_type[projectArr.contract_type] }}</a>
            </p>
            <p>
              <label>合同时间：</label>
              <a>{{ projectArr.contract_start_time }} —— {{ projectArr.contract_end_time }}</a>
            </p>
            <p>
              <label>合同金额：</label>
              <a>{{ projectArr.contract_amount }}</a>
            </p>
            <p>
              <label>税率：</label>
              <a>{{ projectArr.tax_rate }}%</a>
            </p>
          </li>
          <li>
            <p></p>
            <p>
              <template v-if="projectArr.contract_type == 3">
                <label>所属合同：</label>
                <a class="linkwrap normal" @click="link(`/project/detail?id=${projectArr.parent_project_id}`)">
                  <el-link>{{ projectArr.parentContractNo ? projectArr.parentContractNo : '' }}</el-link>
                </a>
              </template>
            </p>
            <p>
              <label>创建合同时间：</label>
              <a>{{ projectArr.create_time }}</a>
            </p>
            <p></p>
            <p>
              <label>税额：</label>
              <a>{{ projectArr.tax }}</a>
            </p>
          </li>
        </ul>
        <div class="form">
          <el-form :ref="newForm" label-width="150px" label-position="left">
            <template>
              <ul class="anlist">
                <li v-for="(item, index) in fileList" :key="index" style="width: 100%;">
                  <div class="abox">
                    <el-form-item :label="`电子合同附件${index + 1}：`">
                      <!-- 选择文件 -->
                      <el-col :span="3"
                        v-if="NodeInclude('247') && projectArr.is_white != '1' && projectArr.status != '5'">
                        <el-upload class="upload-demo" ref="upFile" action="#" :limit="1" :show-file-list="false"
                          :auto-upload="false" accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png"
                          :file-list="item.flist"
                          :on-change="(arg) => uploadFile(arg, 'fileList', 'upFile', item, index)">
                          <el-button size="small" style="width: 80px;">选择文件</el-button>
                        </el-upload>
                      </el-col>
                      <!-- 文件预览及下载 -->
                      <template v-if="item.origin_name">
                        <el-col :span="12">
                          <el-col :span="20">
                            <div class="origin-name">
                              {{
                                item.origin_name }}
                            </div>
                          </el-col>
                          <el-col :span="3">
                            <el-link type="primary" style="margin-right:5px" :href="item.httpFile"
                              target="_blank">查看</el-link>
                          </el-col>
                        </el-col>
                      </template>
                    </el-form-item>
                  </div>
                  <el-button class="bbtn"
                    v-if="index === 0 && NodeInclude('247') && projectArr.is_white != '1' && projectArr.status != '5'"
                    icon="el-icon-plus" @click="addImage(fileList)" circle></el-button>
                  <el-button class="bbtn"
                    v-if="index > 0 && NodeInclude('247') && projectArr.is_white != '1' && projectArr.status != '5'"
                    icon="el-icon-minus" @click="removeImage(fileList, index)" circle></el-button>
                </li>
              </ul>
            </template>
            <template>
              <ul class="anlist">
                <li v-for="(item, index) in fileList1" :key="index" style="width: 100%;">
                  <div class="abox">
                    <el-form-item :label="`盖章合同附件${index + 1}：`">
                      <!-- 选择文件 -->
                      <el-col :span="3"
                        v-if="NodeInclude('39') && projectArr.is_white != '1' && (projectArr.contract_no && projectArr.contract_no != 'TBD') && projectArr.status != '5'">
                        <el-upload class="upload-demo" ref="upFile1" action="#" :limit="1" :show-file-list="false"
                          :auto-upload="false" accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png"
                          :file-list="item.flist"
                          :on-change="(arg) => uploadFile(arg, 'fileList1', 'upFile1', item, index)">
                          <el-button size="small" style="width: 80px;">选择文件</el-button>
                        </el-upload>
                      </el-col>
                      <el-col :span="3"
                        v-else-if="NodeInclude('39') && projectArr.is_white != '1' && projectArr.status != '5'">
                        <el-button size="small" style="width: 80px;" @click="showWrongFn('请先获取合同编号')">选择文件</el-button>
                      </el-col>
                      <!-- 文件预览及下载 -->
                      <template v-if="item.origin_name">
                        <el-col :span="12">
                          <el-col :span="20">
                            <div class="origin-name">
                              {{
                                item.origin_name }}
                            </div>
                          </el-col>
                          <el-col :span="3">
                            <el-link type="primary" style="margin-right:5px" :href="item.httpFile"
                              target="_blank">查看</el-link>
                          </el-col>
                        </el-col>
                      </template>
                    </el-form-item>
                  </div>
                  <el-button class="abtn"
                    v-if="index === 0 && NodeInclude('39') && projectArr.is_white != '1' && projectArr.status != '5'"
                    icon="el-icon-plus" @click="addImage1(fileList1)" circle></el-button>
                  <el-button class="abtn"
                    v-if="index > 0 && NodeInclude('39') && projectArr.is_white != '1' && projectArr.status != '5'"
                    icon="el-icon-minus" @click="removeImage1(fileList1, index)" circle></el-button>
                </li>
              </ul>
            </template>
            <template>
              <ul class="anlist">
                <li v-for="(item, index) in fileList2" :key="index" style="width: 100%;">
                  <div class="abox">
                    <el-form-item :label="`验收报告${index + 1}：`">
                      <!-- 选择文件 -->
                      <el-col :span="3" v-if="projectArr.status != '5' && projectArr.is_white != '1'">
                        <el-upload class="upload-demo" ref="upFile2" action="#" :limit="1" :show-file-list="false"
                          :auto-upload="false" accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png"
                          :file-list="item.flist"
                          :on-change="(arg) => uploadFile(arg, 'fileList2', 'upFile2', item, index)">
                          <el-button size="small" style="width: 100%" v-if="NodeInclude('36')">选择文件</el-button>
                        </el-upload>
                      </el-col>
                      <!-- 文件预览及下载 -->
                      <template v-if="item.origin_name">
                        <el-col :span="12">
                          <el-col :span="20">
                            <div class="origin-name">
                              {{
                                item.origin_name }}
                            </div>
                          </el-col>
                          <el-col :span="3">
                            <el-link type="primary" style="margin-right:5px" :href="item.httpFile"
                              target="_blank">查看</el-link>
                          </el-col>
                        </el-col>
                      </template>
                    </el-form-item>
                  </div>
                  <el-button class="abtn"
                    v-if="index === 0 && NodeInclude('36') && projectArr.is_white != '1' && projectArr.status != '5'"
                    icon="el-icon-plus" @click="addImage2(fileList2)" circle></el-button>
                  <el-button class="abtn"
                    v-if="index > 0 && NodeInclude('36') && projectArr.is_white != '1' && projectArr.status != '5'"
                    icon="el-icon-minus" @click="removeImage2(fileList2, index)" circle></el-button>
                </li>
              </ul>
            </template>
            <el-form-item label
              v-if="projectArr.status != '5' && (NodeInclude('247') || NodeInclude('39') || NodeInclude('36')) && projectArr.is_white != '1'">
              <el-col>
                <!-- <el-button @click="resetForm('newForm')">取消</el-button> -->
                <el-button type="primary" @click="addUpdateProject"
                  style="width: 80px; margin-top: 18px;">确认上传</el-button>
              </el-col>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </div>
    <!-- 项目收入 -->
    <div class="table" v-show="projectArr.contract_type != '2'">
      <h3 class="ntitle">项目收入</h3>
      <div class="operater"
        v-if="billList.length != 0 && NodeInclude('40') && projectArr.is_white != '1' && projectArr.status != '5'">
        <div class="linkline" @click="fillBill">编辑</div>
      </div>
      <template v-if="billList.length == 0 && NodeInclude('40') && projectArr.is_white != '1'">
        <div class="inblank">
          <el-button class="ibtn" icon="el-icon-plus" circle @click="fillBill"></el-button>
          <p>点击创建收款计划</p>
        </div>
      </template>
      <template v-else>
        <ul>
          <li>
            <p>
              <label>合同金额：</label>
              <a>{{ projectArr.contract_amount }}</a>
            </p>
            <p>
              <label>已开票金额：</label>
              <a>{{ totalFinishedInvoice }}</a>
            </p>
          </li>
          <li>
            <p>
              <label>已收款：</label>
              <a>{{ totalReceivedAmount }}</a>
            </p>
            <p>
              <label>未开票金额：</label>
              <a>{{ totalUnFinishedInvoice }}</a>
            </p>
          </li>
          <li>
            <p>
              <label>未收款：</label>
              <a>{{ totalUnReceivedAmount }}</a>
            </p>
            <p>
              <label>已开票未收金额：</label>
              <a>{{ totalFinishedInvoiceNotReceive }}</a>
            </p>
          </li>
        </ul>
        <div class="for">
          <el-table :data="billList" stripe border scroll highlight-current-row>
            <el-table-column prop="bill_name" label="收款计划名称" header-align="center" align="center" min-width="90">
              <template slot-scope="scope">{{ scope.row.bill_name }}</template>
            </el-table-column>
            <el-table-column prop="amount" label="计划收款金额" header-align="center" align="right" min-width="100" />
            <el-table-column prop="estimate_date" label="计划收款时间" header-align="center" align="center" min-width="120">
              <template slot-scope="scope">{{ scope.row.estimate_date != '0000-00-00' ? scope.row.estimate_date :
                scope.row.bill_date }}</template>
            </el-table-column>
            <el-table-column prop="finishedInvoice" label="已开票金额" header-align="center" align="right" min-width="100" />
            <el-table-column prop="unFinishedInvoice" label="未开票金额" header-align="center" align="right"
              min-width="100" />
            <el-table-column prop="invoice_date" label="开票时间" header-align="center" align="center" min-width="120">
              <template slot-scope="scope">{{ scope.row.applyArr ? scope.row.applyArr.invoice_date : '暂无' }}</template>
            </el-table-column>
            <el-table-column prop="receivedAmount" label="已收款" header-align="center" align="right" width="100" />
            <el-table-column prop="unReceivedAmount" label="未收款" header-align="center" align="right" width="100" />
            <el-table-column prop="receive_date" label="收款时间" header-align="center" align="center" min-width="120">
              <template slot-scope="scope">{{ scope.row.applyArr ? scope.row.applyArr.receive_date : '暂无' }}</template>
            </el-table-column>
            <el-table-column prop label="操作" header-align="center" align="center" min-width="250" fixed="right"
              v-if="projectArr.status != '5' && (NodeInclude('41') || NodeInclude('42') || NodeInclude('43') || NodeInclude('44'))">
              <template slot-scope="scope">
                <div class="linkwrap">
                  <!-- apply_status 1是未申请，0已申请 -->
                  <!-- isAllCancel 1是全部作废，0未全部作废 -->
                  <span class="link" :class="{ 'grey': scope.row.applyArr?.apply_status == '0' }"
                    @click="billClick1(scope.row)" v-if="NodeInclude('41') && projectArr.is_white != '1'">{{
                      scope.row.applyArr?.apply_status == '0' ? '已申请开票' : '申请开票' }}</span>
                  <span class="link"
                    :class="{ 'grey': !scope.row.applyArr || scope.row.applyArr?.hope_time == '0000-00-00' }"
                    @click="billClick2(scope.row)" v-if="NodeInclude('42') && projectArr.is_white != '1'">更新发票状态</span>
                  <span class="link" v-if="NodeInclude('43') && projectArr.is_white != '1'"
                    @click="billClick3(scope.row)">更新收款状态</span>
                  <span class="link" v-if="NodeInclude('44')" :class="{ 'grey': !scope.row.applyArr }"
                    @click="billClick4(scope.row)">查看</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop label="操作" header-align="center" align="center" min-width="250px" fixed="right"
              v-else-if="projectArr.status == '5' && (NodeInclude('44'))">
              <template slot-scope="scope">
                <div class="linkwrap">
                  <span class="link" v-if="NodeInclude('44')" :class="{ 'grey': !scope.row.applyArr }"
                    @click="billClick4(scope.row)">查看</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </div>
    <!-- 项目支出 -->
    <div class="table" v-show="projectArr.contract_type != '2'">
      <h3 class="ntitle">项目支出</h3>
      <div class="operater"
        v-if="sonList.length != 0 && NodeInclude('45') && projectArr.is_white != '1' && projectArr.status != '5'">
        <div class="linkline" @click="fillSon">编辑</div>
      </div>
      <template v-if="sonList.length == 0 && NodeInclude('45') && projectArr.is_white != '1'">
        <div class="inblank">
          <el-button class="ibtn" icon="el-icon-plus" circle @click="fillSon"></el-button>
          <p>该项目暂无子项目，点击创建</p>
        </div>
      </template>
      <template v-else-if="sonList.length == 0">
        <div class="inblank">
          <p>该项目暂无子项目，如需新增预算请联系Ryan创建</p>
        </div>
      </template>
      <template v-else>
        <ul>
          <li>
            <p>
              <label>预算：</label>
              <a>{{ totalBudget }}</a>
            </p>
          </li>
          <li>
            <p>
              <label>成本：</label>
              <a>{{ totalCost }}</a>
            </p>
          </li>
          <li>
            <p>
              <label>已支付：</label>
              <a>{{ totalPaid }}</a>
            </p>
          </li>
          <li>
            <p>
              <label>未支付：</label>
              <a>{{ totalUnPaid }}</a>
            </p>
          </li>
        </ul>
        <div class="for grey" v-for="(item, index) in sonList" :key="index">
          <div class="for-title">
            <span v-if="item.id">子项目名称：</span>
            {{ item.contract_name }}
          </div>
          <div class="switch" style="float: right;"
            v-if="NodeInclude('249') && projectArr.is_white != '1' && projectArr.status != '5' && item.id">
            <label style="margin-right: 5px;">是否0成本</label>
            <div class="el-switch"
              :class="{ 'is-checked': item.is_zero == 2, 'cursor': item.payList.length != 0, 'super': level == 1 }"
              @click="switchShow(item)">
              <span class="el-switch__core"></span>
            </div>
          </div>
          <ul v-if="item.id">
            <li>
              <p>
                <label>项目金额：</label>
                <a>{{ item.amount }}</a>
              </p>
            </li>
            <li>
              <p>
                <label>项目起止时间：</label>
                <a>{{ item.start_time }} — {{ item.end_time }}</a>
              </p>
            </li>
          </ul>
          <div class="flex-box1" v-if="item.id">
            <div class="left">
              <ul class="left-ul">
                <li>
                  <p>
                    <label style="width: auto;">预算：</label>
                    <a>{{ item.sonTotalBudget }}</a>
                  </p>
                </li>
                <li>
                  <p>
                    <label style="width: auto;">成本：</label>
                    <a>{{ item.sonTotalCost }}</a>
                  </p>
                </li>
                <li>
                  <p>
                    <label style="width: auto;">已支付：</label>
                    <a>{{ item.sonTotalPaidAmount }}</a>
                  </p>
                </li>
                <li>
                  <p>
                    <label style="width: auto;">未支付：</label>
                    <a>{{ item.sonTotalNoPaidAmount }}</a>
                  </p>
                </li>
              </ul>
            </div>
            <div class="right" style="text-algin: right;">
              <el-button round icon="el-icon-plus" @click="addClick(item)" style="width:100px;margin: 15px;"
                v-if="item.is_zero == '1' && ((NodeInclude('46') && projectArr.is_white != '1' && item.canBudget) || level == '1') && projectArr.status != '5'">新增</el-button>
              <el-button round @click="showBudget(item)" style="width:100px; margin: 0;"
                v-if="item.is_zero == '1' && NodeInclude('47') && projectArr.is_white != '1' && projectArr.status != '5'">提交预算</el-button>
            </div>
          </div>
          <div>
            <el-table :data="item.payList" stripe border scroll v-if="item.payList.length != 0" highlight-current-row>
              <el-table-column prop="service_type" label="服务类目" header-align="center" align="center" min-width="120">
                <template slot-scope="scope">
                  <span v-if="scope.row.is_customer == 1">{{ scope.row.service_type_name }}</span>
                  <span v-else>{{ scope.row.service_type_name }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="service_info" label="服务说明" header-align="center" align="left" min-width="300" />
              <el-table-column prop="pay_type" label="支付类别" header-align="center" align="center" min-width="80">
                <template slot-scope="scope">{{ dd.pay_type[scope.row.pay_type] }}</template>
              </el-table-column>
              <el-table-column prop="vendor" label="供应商名称" header-align="center" align="center" min-width="250">
                <template slot-scope="scope">
                  <div class="linkwrap normal">
                    <el-link style="font-size: 12px;" @click="showVendor(scope.row, item.id)">
                      {{ scope.row.vendorArr ?
                        scope.row.vendorArr.vendor : '点击选择供应商' }}
                    </el-link>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="contract_no" label="供应商合同编号" header-align="center" align="center" width="300">
                <template slot-scope="scope">
                  <div v-if="scope.row.contract_id == '-1'">无需合同</div>
                  <div class="linkwrap normal" v-else>
                    <el-link @click="showPurchase(scope.row, item.id)" style="font-size: 12px;">
                      {{ scope.row.vendorContractArr ? (scope.row.vendorContractArr.contract_no == 'TBD' ?
                        `${scope.row.vendorContractArr.contract_no}-${scope.row.vendorContractArr.contract_name}` :
                        scope.row.vendorContractArr.contract_no) : '点击选择供应商合同' }}
                    </el-link>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="budget" label="预算" header-align="center" align="right" min-width="100" />
              <el-table-column prop="cost" label="成本" header-align="center" align="right" min-width="100" />
              <el-table-column prop="budget_status" label="预算审核" header-align="center" align="center" min-width="120">
                <template slot-scope="scope">
                  <span @click="budgetReson(scope.row)" style="cursor: pointer;">
                    {{
                      dd.budget_status[scope.row.budget_status] }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="plan_amount" label="支付计划" header-align="center" align="right" min-width="250">
                <template slot-scope="scope">
                  <div v-for="(item, index) in scope.row.planList" :key="index">{{ item.plan_name ? item.plan_name + '：'
                    : '' }} {{ item.plan_amount }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="pay_check_status" label="支付审核" header-align="center" align="center"
                min-width="200">
                <template slot-scope="scope">
                  <div v-for="(item, index) in scope.row.planList" :key="index" @click="payReson(item)"
                    style="cursor: pointer;">{{ item.plan_name ? item.plan_name + '：' : '' }} {{
                      dd.pay_check_status[item.pay_check_status] }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="paidAmount" label="已支付" header-align="center" align="right" min-width="100" />
              <el-table-column prop="noPaidAmount" label="未支付" header-align="center" align="right" min-width="100" />
              <el-table-column prop label="操作" header-align="center" align="center" min-width="380" fixed="right"
                v-if="projectArr.status != '5'">
                <template slot-scope="scope">
                  <!-- is_customer 行政 -->
                  <div class="linkwrap" v-if="scope.row.is_customer == 1">
                    <span class="link"
                      @click="link(`/admin/view?id=${scope.row.project_id}&mType=${scope.row.projectArr?.project_type}`)"
                      v-if="NodeInclude('127')">查看</span>
                  </div>
                  <div class="linkwrap" v-else>
                    <span class="link" @click="delClick(scope.row)"
                      v-if="NodeInclude('248') && projectArr.is_white != '1'">删除</span>
                    <span class="link" @click="applyPayClick(scope.row)"
                      v-if="NodeInclude('49') && projectArr.is_white != '1'">申请支付</span>
                    <span class="link"
                      :class="{ 'grey': (scope.row.budget_status == '3' || scope.row.budget_status == '4') }"
                      @click="budgetCheckClick(scope.row)"
                      v-if="(NodeInclude('48') || NodeInclude('339')) && projectArr.is_white != '1'">预算审核</span>
                    <span class="link" @click="payCheckClick(scope.row)"
                      v-if="NodeInclude('50') && projectArr.is_white != '1'">支付审核</span>
                    <span class="link" @click="updatePayClick(scope.row)"
                      v-if="NodeInclude('51') && projectArr.is_white != '1'">更新支付状态</span>
                    <span class="link" @click="viewClick(scope.row)" v-if="NodeInclude('52')">编辑</span>
                    <span class="link" @click="changeClick(scope.row)"
                      v-if="NodeInclude('53') && projectArr.is_white != '1'">移动</span>
                    <span class="link" @click="checkClick(scope.row)" v-if="NodeInclude('426') && projectArr.is_white != '1'">比价</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop label="操作" header-align="center" align="center" min-width="80" fixed="right" v-else>
                <template slot-scope="scope">
                  <!-- is_customer 行政 -->
                  <div class="linkwrap" v-if="scope.row.is_customer == 1">
                    <span class="link"
                      @click="link(`/admin/view?id=${scope.row.project_id}&mType=${scope.row.projectArr?.project_type}`)"
                      v-if="NodeInclude('127')">查看</span>
                  </div>
                  <div class="linkwrap" v-else>
                    <span class="link" @click="viewClick(scope.row)" v-if="NodeInclude('52')">查看</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <el-table :data="emptyList" v-else></el-table>
          </div>
        </div>
      </template>
    </div>
    <!-- 项目动态 -->
    <div class="history">
      <h3 class="ntitle">项目动态</h3>
      <el-form ref="trackForm" :model="trackForm" style="float:right;" v-if="projectArr.status != '5'">
        <el-form-item label prop="track_event">
          <el-col :span="20">
            <el-select v-model="trackForm.event_id" placeholder="请选择流程" style="margin-right: 0; width: 100%;"
              @change="trackChange">
              <el-option label="全部流程" value="0"></el-option>
              <el-option label="项目合同" value="1"></el-option>
              <el-option label="预算管理" value="9"></el-option>
              <el-option label="成本管理" value="2"></el-option>
              <el-option label="供应商合同" value="3"></el-option>
              <el-option label="支付管理" value="4"></el-option>
              <el-option label="发票管理" value="5"></el-option>
              <el-option label="项目收款" value="6"></el-option>
              <el-option label="项目状态" value="7"></el-option>
              <el-option label="项目补充" value="8"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
      </el-form>
      <ul class="linehead">
        <li>时间</li>
        <li>操作人</li>
        <li>流程</li>
        <li>详情</li>
      </ul>
      <div class="timeline">
        <el-timeline>
          <el-timeline-item :timestamp="compDate(item)" placement="top" v-for="(item, index) in myTrackList"
            :key="index" :class="{ child: !item.parent }" :icon="item.icon" :color="item.color">
            <!-- <div class="ico-edit" @click="setTrackId(item)" v-if="projectArr.status != '5'"><i class="el-icon-edit"></i></div>-->
            <div class="ico-edit"
              v-if="projectArr.status != '5' && (NodeInclude('54') || NodeInclude('250')) && projectArr.is_white != '1'">
              <el-dropdown trigger="click" placement="bottom-start" @command="handleCommand">
                <i class="el-icon-edit" @click="setTimeForm(item)"></i>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item command="a" v-if="NodeInclude('54')">新增</el-dropdown-item>
                    <el-dropdown-item command="b" v-if="NodeInclude('54')">编辑</el-dropdown-item>
                    <el-dropdown-item command="c" v-if="NodeInclude('250')">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
            <div class="mycard" :class="{ active: parentActive(item), parent: item.parent }" @click="trigger(item)">
              <!-- {{item}} -->
              <i class="point" v-if="item.point">+{{ item.point }}</i>
              <div v-if="!item.parent">
                <ul class="ul">
                  <li>
                    <span>{{ item.bkUserArr ? `${item.bkUserArr.realname} ${item.bkUserArr.en_name}` : '暂无' }}</span>
                  </li>
                  <li>
                    <span>{{ item.eventName }}</span>
                  </li>
                  <li v-html="item.info"></li>
                </ul>
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>

    <el-dialog :title="currCost.is_zero == 1 ? '请确认该子项目是否修改为0成本？' : '修改为非0成本'" :visible.sync="costShow" width="600px">
      <ul class="aul" style="padding:0">
        <li>
          <span style="width: 80%;text-align:left; line-height: 30px;">子项目名称：{{ currCost.contract_name }}</span>
          <br />
          <span style="width: 80%;text-align:left; line-height: 30px;">
            {{ currCost.is_zero == 1 ? '注意：确认后将无法为该项目新增预算' :
              '' }}
          </span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="costShow = false">取 消</el-button>
        <el-button type="primary" @click="handleCost">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="项目状态" :visible.sync="statusShow" width="600px">
      <div style="padding: 30px 0;">
        <el-col :span="24">
          <el-radio-group v-model="currstatus">
            <el-radio label="1">未开始</el-radio>
            <el-radio label="2">进行中</el-radio>
            <el-radio label="3">项目终止</el-radio>
            <el-radio label="4">已完成</el-radio>
            <el-radio label="5">已归档</el-radio>
          </el-radio-group>
        </el-col>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="statusShow = false">取 消</el-button>
        <el-button type="primary" @click="handleStatus">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="项目交接" :visible.sync="handoverShow" width="400px">
      <div style="padding: 30px 0;">
        <el-col :span="24">
          <el-select v-model="handoverForm.user_id" placeholder="请选择" clearable filterable style="width:100%;">
            <el-option :label="`${v.realname} ${v.en_name}`" :value="v.id" v-for="(v, i) in departList"
              :key="`dep_${i}`"></el-option>
          </el-select>
        </el-col>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handoverShow = false">取 消</el-button>
        <el-button type="primary" @click="handleHandover">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="审核信息" :visible.sync="resonShow" width="600px" v-if="currReason">
      <ul class="aul" style="padding:0">
        <li>
          <span style="white-space: pre-wrap;">{{ currReason.reason }}</span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="resonShow = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="timeForm.option == 1 ? '新增合同动态' : '编辑合同动态'" :visible.sync="trackShow" width="600px">
      <el-form ref="timeForm" :model="timeForm" label-width="220px" label-position="left" class="ulform">
        <el-form-item label="选择时间：" prop="create_time">
          <el-col :span="24">
            <el-date-picker v-model="timeForm.create_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择时间" style="width:100%;"></el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="选择操作人：" prop="bk_uid">
          <el-col :span="24">
            <el-select v-model="timeForm.bk_uid" placeholder="请选择" clearable filterable style="width:100%;">
              <el-option :label="v.realname" :value="v.id" v-for="(v, i) in userList" :key="i"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="选择流程：" prop="event_id">
          <el-col :span="24">
            <el-select v-model="timeForm.event_id" placeholder="请选择" style="width: 100%;">
              <el-option label="全部流程" value="0"></el-option>
              <el-option label="项目合同" value="1"></el-option>
              <el-option label="预算管理" value="9"></el-option>
              <el-option label="成本管理" value="2"></el-option>
              <el-option label="供应商合同" value="3"></el-option>
              <el-option label="支付管理" value="4"></el-option>
              <el-option label="发票管理" value="5"></el-option>
              <el-option label="项目收款" value="6"></el-option>
              <el-option label="项目状态" value="7"></el-option>
              <el-option label="项目补充" value="8"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="备注：" prop="info">
          <el-col :span="24">
            <el-input style="width: 100%;" type="textarea" spellcheck="false" :autosize="{ minRows: 4 }"
              placeholder="请输入内容" v-model="timeForm.info"></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="trackShow = false">取 消</el-button>
        <el-button type="primary" @click="handleTrack">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="删除合同动态" :visible.sync="delTrackShow" width="600px">
      <ul class="aul ulist" style="padding:0; min-height: 100px;">
        <li>
          <span>时间：</span>
          <span>{{ timeForm.create_time }}</span>
        </li>
        <li>
          <span>操作人：</span>
          <span>{{ timeForm.bkUserArr ? timeForm.bkUserArr.realname : '暂无' }}</span>
        </li>
        <li>
          <span>项目状态：</span>
          <span>{{ dd.track_type[timeForm.event_id] }}</span>
        </li>
        <li>
          <span>详情：</span>
          <span v-html="timeForm.info"></span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delTrackShow = false">取 消</el-button>
        <el-button type="primary" @click="deleteTrack">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="删除提醒" :visible.sync="delShow" width="800px" v-if="currDel">
      <ul class="aul" style="padding:0">
        <li>
          <label>温馨提示：</label>
          <span>您是否确定删除该预算</span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delShow = false">取 消</el-button>
        <el-button type="primary" @click="handleDel">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提交预算" :visible.sync="budgetShow" width="1000px">
      <el-table :data="budgetPayList" stripe border scroll highlight-current-row>
        <el-table-column prop="service_type" label="服务类目" header-align="center" align="center" min-width="120">
          <template slot-scope="scope">{{ scope.row.service_type_name }}</template>
        </el-table-column>
        <el-table-column prop="service_info" label="服务说明" header-align="center" align="left" min-width="300" />
        <el-table-column prop="vendor" label="供应商名称" header-align="center" align="center" min-width="200">
          <template slot-scope="scope">{{ scope.row.vendorArr.vendor }}</template>
        </el-table-column>
        <el-table-column prop="budget" label="预算" header-align="center" align="center"
          min-width="300"></el-table-column>
        <el-table-column prop="cost" label="成本" header-align="center" align="center" min-width="300">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.planList" :key="index">{{ item.plan_name ? item.plan_name + '：' : ''
            }}{{ item.plan_amount }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div style="padding: 20px 0;">温馨提示：您是否确定提交{{ budgetTotal }}条预算</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="budgetShow = false">取 消</el-button>
        <el-button type="primary" @click="handleBudget">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="支付申请" :visible.sync="payShow" width="600px" v-if="currToPay">
      <ul class="aul ulist" style="padding:0">
        <li>
          <span>客户公司名称：</span>
          <span>{{ projectArr.client_company }}</span>
        </li>
        <li>
          <span>品牌：</span>
          <span>{{ projectArr.brand }}</span>
        </li>
        <li>
          <span>项目名称：</span>
          <span>{{ projectArr.contract_name }}</span>
        </li>
        <li>
          <span>子项目名称：</span>
          <span>{{ currToPay.son_contract_name }}</span>
        </li>
        <li>
          <span>服务类目：</span>
          <span>{{ currToPay.service_type_name }}</span>
        </li>
        <li>
          <span>服务说明：</span>
          <span class="info-height">{{ currToPay.service_info }}</span>
        </li>
        <li>
          <span>供应商名称：</span>
          <span>{{ currToPay.vendorArr ? currToPay.vendorArr.vendor : '暂无' }}</span>
        </li>
        <li>
          <span>支付类别：</span>
          <span>{{ dd.pay_type[currToPay.pay_type] }}</span>
        </li>
        <li>
          <span>供应商合同：</span>
          <span>{{ currToPay.contract_id == '-1' ? '无需合同' : (currToPay.vendorContractArr ? '有合同' : '暂无') }}</span>
        </li>
        <li>
          <span>供应商发票合计金额：</span>
          <span>{{ currToPay.vendorTotalInvoice }}</span>
        </li>
        <li>
          <span>项目验收：</span>
          <span>{{ currToPay.check_info ? '已验收' : '未验收' }}</span>
        </li>
        <el-form ref="payForm" :model="payForm" label-width="220px" label-position="left" class="ulform">
          <el-form-item label="选择支付计划：" prop="plan_id">
            <el-col :span="24">
              <el-select v-model="payForm.plan_id" placeholder="请选择" @change="planChange" style="width:100%;">
                <el-option :label="v.plan_name" :value="v.id" v-for="(v, i) in currToPay.planList" :key="i"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="计划付款金额：" prop="plan_amount">
            <el-col :span="24">{{ payForm.plan_amount }}</el-col>
          </el-form-item>
          <el-form-item label="计划付款时间：" prop="hope_pay_time">
            <el-col :span="24">{{ payForm.hope_pay_time }}</el-col>
          </el-form-item>
        </el-form>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="payShow = false">取 消</el-button>
        <el-button type="primary" @click="handleApply">申 请</el-button>
      </span>
    </el-dialog>

    <el-dialog title="预算审核" :visible.sync="budgetCheckShow" width="600px" v-if="currbudgetCheck">
      <ul class="aul ulist" style="padding:0">
        <li>
          <span>客户公司名称：</span>
          <span>{{ projectArr.client_company }}</span>
        </li>
        <li>
          <span>品牌：</span>
          <span>{{ projectArr.brand }}</span>
        </li>
        <li>
          <span>项目名称：</span>
          <span>{{ projectArr.contract_name }}</span>
        </li>
        <li>
          <span>子项目名称：</span>
          <span>{{ currbudgetCheck.son_contract_name }}</span>
        </li>
        <li>
          <span>服务类目：</span>
          <span>{{ currbudgetCheck.service_type_name }}</span>
        </li>
        <li>
          <span>服务说明：</span>
          <span class="info-height">{{ currbudgetCheck.service_info }}</span>
        </li>
        <li>
          <span>预算：</span>
          <span>{{ currbudgetCheck.budget }}</span>
        </li>
        <li>
          <span>成本：</span>
          <span>{{ currbudgetCheck.cost }}</span>
        </li>
        <li>
          <span>供应商名称：</span>
          <span>{{ currbudgetCheck.vendorArr ? currbudgetCheck.vendorArr.vendor : '暂无' }}</span>
        </li>
        <li>
          <span>供应商合同金额：</span>
          <span>{{ currbudgetCheck.vendorContractArr ? currbudgetCheck.vendorContractArr.contract_amount : '暂无'
          }}</span>
        </li>
        <el-form ref="bugetCheckForm" :model="bugetCheckForm" label-width="220px" label-position="left" class="ulform">
          <el-form-item label="预算审核：" prop="budget_status">
            <el-col :span="24">
              <el-radio-group v-model="bugetCheckForm.budget_status">
                <el-radio label="3">通过</el-radio>
                <el-radio label="4">不通过</el-radio>
              </el-radio-group>
            </el-col>
          </el-form-item>
          <template v-if="bugetCheckForm.budget_status == '3'">
            <el-form-item label prop="budget_check_info">
              <el-col :span="24">
                <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
                  v-model="bugetCheckForm.budget_check_info"></el-input>
              </el-col>
            </el-form-item>
          </template>
          <template v-if="bugetCheckForm.budget_status == '4'">
            <el-form-item label prop="budget_check_reason">
              <el-col :span="24">
                <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
                  v-model="bugetCheckForm.budget_check_reason"></el-input>
              </el-col>
            </el-form-item>
          </template>
        </el-form>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="budgetCheckShow = false">取 消</el-button>
        <el-button type="primary" @click="handleBudgetCheck">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="支付审核" :visible.sync="payCheckShow" width="600px" v-if="currPayCheck">
      <ul class="aul ulist" style="padding:0; min-height: 600px;">
        <li>
          <span>客户公司名称：</span>
          <span>{{ projectArr.client_company }}</span>
        </li>
        <li>
          <span>品牌：</span>
          <span>{{ projectArr.brand }}</span>
        </li>
        <li>
          <span>项目名称：</span>
          <span>{{ projectArr.contract_name }}</span>
        </li>
        <li>
          <span>子项目名称：</span>
          <span>{{ currPayCheck.son_contract_name }}</span>
        </li>
        <li>
          <span>服务类目：</span>
          <span>{{ currPayCheck.service_type_name }}</span>
        </li>
        <li>
          <span>服务说明：</span>
          <span class="info-height">{{ currPayCheck.service_info }}</span>
        </li>
        <li>
          <span>供应商名称：</span>
          <span>{{ currPayCheck.vendorArr ? currPayCheck.vendorArr.vendor : '暂无' }}</span>
        </li>
        <li>
          <span>支付类别：</span>
          <span>{{ dd.pay_type[currPayCheck.pay_type] }}</span>
        </li>
        <li>
          <span>供应商合同：</span>
          <span>{{ currPayCheck.contract_id == '-1' ? '无需合同' : (currPayCheck.vendorContractArr ? '有合同' : '暂无') }}</span>
        </li>
        <li>
          <span>供应商发票合计金额：</span>
          <span>{{ currPayCheck.vendorTotalInvoice }}</span>
        </li>
        <li>
          <span>项目验收：</span>
          <span>{{ currPayCheck.check_info ? '已验收' : '未验收' }}</span>
        </li>
        <el-form ref="payCheckForm" :model="payCheckForm" label-width="220px" label-position="left" class="ulform">
          <el-form-item label="选择支付计划：" prop="plan_id">
            <el-col :span="24">
              <el-select v-model="payCheckForm.plan_id" placeholder="请选择" @change="planCheckChange" style="width:100%;">
                <el-option :label="v.plan_name" :value="v.id" v-for="(v, i) in currPayCheck.planList"
                  :key="i"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="计划支付时间：" prop="hope_pay_time">{{ payCheckForm.hope_pay_time }}</el-form-item>
          <el-form-item label="计划支付金额：" prop="plan_amount">
            <el-col :span="24">{{ payCheckForm.plan_amount }}</el-col>
          </el-form-item>
          <el-form-item label="风险提醒：" prop>
            <el-col :span="24">无</el-col>
          </el-form-item>
          <el-form-item label="审核：" prop="pay_check_status">
            <el-col :span="24">
              <el-radio-group v-model="payCheckForm.pay_check_status">
                <el-radio label="3">通过</el-radio>
                <el-radio label="4">不通过</el-radio>
              </el-radio-group>
            </el-col>
          </el-form-item>
          <template v-if="payCheckForm.pay_check_status == '3'">
            <el-form-item label prop="pay_check_info">
              <el-col :span="24">
                <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
                  v-model="payCheckForm.pay_check_info"></el-input>
              </el-col>
            </el-form-item>
          </template>
          <template v-if="payCheckForm.pay_check_status == '4'">
            <el-form-item label prop="pay_check_reason">
              <el-col :span="24">
                <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
                  v-model="payCheckForm.pay_check_reason"></el-input>
              </el-col>
            </el-form-item>
          </template>
        </el-form>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="payCheckShow = false">取 消</el-button>
        <el-button type="primary" @click="handlePayCheck">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="合同申请" :visible.sync="conShow" width="400px">
      <ul class="aul" style="padding:0">
        <li>
          <span>请确认是否进行合同申请？</span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="conShow = false">取 消</el-button>
        <el-button type="primary" @click="handleConApply(2)">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="选择供应商" :visible.sync="vendorShow" width="500px">
      <el-form ref="vendorForm" :model="vendorForm" label-width="150px" label-position="left" class="ulform">
        <el-form-item label="选择供应商名称：" prop="vendor_id">
          <el-col :span="24">
            <el-select v-model="vendorForm.vendor_id" placeholder="请选择" style="margin-right: 0; width: 100%;"
              @change="vendorChange" @clear="vendorChange" clearable filterable>
              <el-option :label="v.vendor" :value="v.id" v-for="(v, i) in vendorList" :key="i"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showNewVendor">没有相关供应商，点击下载《供应商登记表》</el-button>
      </span>
    </el-dialog>

    <el-dialog title="下载供应商登记表" :visible.sync="newVendorShow" width="500px">
      <span>按照登记表补充供应商信息，联系Jaunty新增</span>
      <span slot="footer" class="dialog-footer">
        <el-link class="dialog-download" :href="`http://${host}/images/download/供应商信息登记表（个人）20230412.xlsx`"
          target="_blank">个人供应商</el-link>
        <el-link class="dialog-download" :href="`http://${host}/images/download/供应商信息登记表（公司）20230412.xlsx`"
          target="_blank">公司供应商</el-link>
      </span>
    </el-dialog>

    <el-dialog title="选择供应商合同" :visible.sync="purchaseShow" width="500px">
      <el-form ref="vendorForm" :model="vendorForm" label-width="150px" label-position="left" class="ulform">
        <el-form-item label="选择供应商合同：" prop="contract_id">
          <el-col :span="24">
            <el-select v-model="vendorForm.contract_id" placeholder="请选择" style="margin-right: 0; width: 100%;"
              @change="purchaseChange" filterable>
              <el-option :label="v.contract_no + '-' + v.contract_name" :value="v.id" v-for="(v, i) in purchaseList"
                :key="i" :disabled="v.beChoosed == '1'"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addPurchase(vendorForm)">没有相关合同，新建供应商合同</el-button>
      </span>
    </el-dialog>

    <el-dialog title="移动支出到对应子项目" :visible.sync="changeShow" width="600px">
      <ul class="aul ulist" style="padding:0; height: 200px;">
        <li>
          <span>服务类目：</span>
          <span>{{ changeForm.service_type_name }}</span>
        </li>
        <li>
          <span>服务说明：</span>
          <span>{{ changeForm.service_info }}</span>
        </li>
        <li>
          <span>预算：</span>
          <span>{{ changeForm.budget }}</span>
        </li>
        <el-form ref="bugetCheckForm" :model="changeForm" label-width="220px" label-position="left" class="ulform">
          <el-form-item label="移动到子项目：" prop="budget_status">
            <el-col :span="24">
              <el-select v-model="changeForm.son_project_id" placeholder="请选择" style="margin-right: 0; width: 100%;"
                clearable filterable>
                <el-option :label="v.contract_name" :value="v.id" v-for="(v, i) in sonList" :key="i"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </el-form>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changeShow = false">取 消</el-button>
        <el-button type="primary" @click="changeOther">确定移动</el-button>
      </span>
    </el-dialog>

    <el-dialog title="比价" :visible.sync="checkLay" width="500px">
      <el-form ref="vendorForm" :model="checklayForm" label-width="150px" label-position="left" class="ulform">
        <el-form-item label="选择供应商名称：" prop="vendor_id">
          <el-col :span="24">
            <el-select ref="vVendor" v-model="checklayForm.vendor_id" placeholder="请选择"
              style="margin-right: 0; width: 100%;" @change="v => changeData(v, 'vVendor')" clearable filterable>
              <el-option :label="v.vendor" :value="v.id" v-for="(v, i) in vendorList" :key="i"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="服务类目：" prop="cate_id_array">
          <el-col :span="24">
            <el-cascader ref="cateIdArray" v-model="checklayForm.cate_id_array" :options="checklayForm.selectTypeList"
              :props="{ expandTrigger: 'hover', checkStrictly: false }" style="margin-right: 0; width: 100%;"
              @change="v => changeData(v, 'cateIdArray')"></el-cascader>
          </el-col>
        </el-form-item>
        <el-form-item label="描述：" prop="card_desc">
          <el-col :span="24">
            <el-select ref="cardDesc" placeholder="请选择" v-model="checklayForm.card_desc"
              @change="v => changeData(v, 'cardDesc')" style="margin-right: 0; width: 100%;" filterable>
              <el-option :label="v.card_desc" :value="v.card_desc" v-for="(v, i) in checklayForm.descList"
                :key="`desc_${i}`"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="goCheck">前往比价</el-button>
      </span>
    </el-dialog>
  </el-main>
</template>

<script>
import * as api from "@/api";
import { thousands, antiThousands } from "@/utils/index.js";
import store from "@/store";
export default {
  name: "proView",
  data() {
    return {
      nodeLimtList: [],
      userList: [],
      departList: [],
      host: "",
      canChangeVendor: true,
      is_apply: "",
      level: "",
      billList: [],
      projectArr: {
        status: ""
      },
      sonList: [{ amount: "", payList: [] }],
      vendorList: [],
      purchaseList: [],
      totalFinishedInvoiceNotReceive: "",
      totalFinishedInvoice: "",
      totalInvoiceUnReceive: "",
      totalReceivedAmount: "",
      totalUnFinishedInvoice: "",
      totalUnReceivedAmount: "",
      totalBudget: 0,
      totalCost: 0,
      totalPaid: 0,
      totalUnPaid: 0,
      payForm: {
        plan_id: "",
        hope_pay_time: "",
        plan_amount: ""
      },
      bugetCheckForm: {
        option: 2,
        pay_id: "",
        budget_status: "4",
        budget_check_info: "",
        budget_check_reason: ""
      },
      payCheckForm: {
        plan_id: "",
        hope_pay_time: "",
        apply_amount: "",
        plan_amount: "",
        pay_check_status: "4",
        pay_check_reason: "",
        pay_check_info: ""
      },
      trackForm: {
        project_id: "",
        event_id: ""
      },
      delTrackShow: false,
      timeForm: {
        track_id: "",
        create_time: "",
        bk_uid: "",
        event_id: "",
        info: "",
        option: 1
      },
      canGetNo: true,
      trackList: [],
      emptyList: [], //0成本数组
      total: 0,
      p: 1,
      perPage: 30,
      budgetShow: false,
      budgetPayList: [],
      budgetTotal: "",
      costShow: false,
      currCost: {
        //son数组
      },
      statusShow: false,
      currstatus: "",
      resonShow: false,
      currReason: {
        //当前原因数组
      },
      // timeShow: false,
      // currTime: {//当前时间数组

      // },
      trackShow: false,
      currTrack: {
        //当前动态
      },
      delShow: false,
      currDel: {
        //当前删除的数组
      },
      payShow: false,
      currToPay: {
        //当前支付申请数组
      },
      budgetCheckShow: false,
      currbudgetCheck: {
        //当前预算审核
      },
      payCheckShow: false,
      currPayCheck: {
        //当前支付审核
      },
      conShow: false,
      newForm: {},
      vendorShow: false,
      vendorForm: {}, //更改供应商
      changeShow: false,
      changeForm: {},
      newVendorShow: false,
      purchaseShow: false,
      handoverShow: false, //交接
      handoverForm: {
        user_id: ""
      },
      fileList: [
        { origin_name: "", file_name: "", httpFile: "", file_id: "", flist: [] }
      ],
      fileList1: [
        { origin_name: "", file_name: "", httpFile: "", file_id: "", flist: [] }
      ],
      fileList2: [
        { origin_name: "", file_name: "", httpFile: "", file_id: "", flist: [] }
      ],
      del_atta_list: [],
      del_atta_list1: [],
      del_atta_list2: [],
      checkLay: false,
      checklayForm: {

      },
    };
  },
  mounted() {
    this.getUserList();
  },
  computed: {
    parentActive() {
      return item => {
        return item.parent && item.active;
      };
    },
    myTrackList() {
      return this.trackList.filter(item => item);
    }
  },
  created() {
    this.host =
      window.location.host.search("192") === -1
        ? window.location.host
        : `devoa.minuteschina.com`;
    this.query.id && this.getProjectDetail(this.query.id);
  },
  watch: {
    ["projectArr.pay_bank_account"](val) {
      if (val != undefined) {
        this.$nextTick(() => {
          this.projectArr.pay_bank_account = val
            .replace(/\D/g, "")
            .replace(/....(?!$)/g, "$& ");
        });
      }
    }
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;
      // 移除'#'字符  
      const url = hash.substring(1);

      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id
      };
      api.checkNode(postData).then(res => {
        this.nodeLimtList = res.node_ids.split(",");
      });
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val);
    },
    async getUserList() {
      this.$fly
        .post("apiAccount_getUserList.html", {
          per_page: 5000
        })
        .then(res => {
          this.userList = res.itemList;
        });
    },
    getDepartList(user_id) {
      this.$fly
        .post("apiAccount_getHandoverList.html", {
          user_id
        })
        .then(res => {
          this.departList = res;
        });
    },
    getProjectNo() {
      if (this.is_apply == 1) {
        this.$message.error("该合同暂未提交合同申请");
        return false;
      }
      this.$fly
        .post("apiProject_getUpdateContractNo.html", {
          project_id: this.query.id
        })
        .then(res => {
          this.projectArr.contract_no = res.contractNo;
          this.$message.success("获取成功");
          this.query.id && this.getProjectDetail(this.query.id);
        });
    },
    getProjectDetail(id) {
      this.checkUrlFn();
      this.checkNodeFn("61");
      api.getProjectDetail({ project_id: id }).then(res => {
        this.billList = res.billList;
        this.projectArr = res.itemArr;
        this.sonList = res.sonList;
        this.trackList = res.trackList;
        //is_apply
        this.is_apply = this.projectArr.is_apply;
        delete this.projectArr.is_apply;
        this.projectArr.contract_amount = thousands(
          Number(this.projectArr.contract_amount)
        );
        this.projectArr.tax = thousands(Number(this.projectArr.tax));
        //收入总值
        this.totalFinishedInvoiceNotReceive = thousands(
          Number(res.totalFinishedInvoice) - Number(res.totalReceivedAmount)
        );
        this.totalFinishedInvoice = thousands(res.totalFinishedInvoice);
        this.totalInvoiceUnReceive = thousands(res.totalFinishedInvoice);
        this.totalReceivedAmount = thousands(res.totalReceivedAmount);
        this.totalUnFinishedInvoice = thousands(res.totalUnFinishedInvoice);
        this.totalUnReceivedAmount = thousands(res.totalUnReceivedAmount);
        //清空计算值
        this.totalBudget = 0;
        this.totalCost = 0;
        this.totalPaid = 0;
        this.totalUnPaid = 0;
        //支出总值
        const tempSonList = this.sonList.filter(item => item.id);
        tempSonList.costNum = 0;
        tempSonList.budgetNum = 0;
        tempSonList.zeroBen = 0;
        for (let i = 0; i < tempSonList.length; i++) {
          const _budget = Number(tempSonList[i].sonTotalBudget);
          if (!isNaN(_budget) && tempSonList[i].is_zero != "2") {
            this.totalBudget += _budget;
          } else {
            tempSonList.budgetNum += 1; //'暂无'
          }
          const _cost = Number(tempSonList[i].sonTotalCost);
          if (!isNaN(_cost) && tempSonList[i].is_zero != "2") {
            this.totalCost += _cost;
          } else {
            tempSonList.costNum += 1; //'暂无'
          }
          const _paid = Number(tempSonList[i].sonTotalPaidAmount);
          this.totalPaid += _paid;
          const _unpaid = Number(tempSonList[i].sonTotalNoPaidAmount);
          this.totalUnPaid += _unpaid;
          //payList为空且为0成本，显示是0
          if (tempSonList[i].is_zero == "2") {
            tempSonList.zeroBen += 1;
          }
        }

        this.totalBudget =
          this.totalBudget == 0 && tempSonList.budgetNum == tempSonList.length
            ? tempSonList.zeroBen == tempSonList.length
              ? "0.00"
              : "暂无"
            : thousands(this.totalBudget);
        this.totalCost =
          this.totalCost == 0 && tempSonList.costNum == tempSonList.length
            ? tempSonList.zeroBen == tempSonList.length
              ? "0.00"
              : "暂无"
            : thousands(this.totalCost);
        this.totalPaid = thousands(this.totalPaid);
        this.totalUnPaid = thousands(this.totalUnPaid);
        //格式化单项
        this.billList = this.billList.map(item => {
          item.amount = thousands(Number(item.amount));
          item.receivedAmount = thousands(Number(item.receivedAmount));
          item.unFinishedInvoice = thousands(Number(item.unFinishedInvoice));
          item.unReceivedAmount = thousands(Number(item.unReceivedAmount));
          item.finishedInvoice = thousands(Number(item.finishedInvoice));
          return item;
        });
        this.sonList = this.sonList.map(item => {
          item.amount = thousands(Number(item.amount));
          item.sonTotalBudget =
            item.sonTotalBudget != "暂无"
              ? thousands(Number(item.sonTotalBudget))
              : item.sonTotalBudget;
          item.sonTotalCost =
            item.sonTotalCost != "暂无"
              ? thousands(Number(item.sonTotalCost))
              : item.sonTotalCost;
          item.sonTotalNoPaidAmount = thousands(
            Number(item.sonTotalNoPaidAmount)
          );
          item.sonTotalPaidAmount = thousands(Number(item.sonTotalPaidAmount));
          return item;
        });
        for (let i = 0; i < this.sonList.length; i++) {
          let _payList = this.sonList[i].payList;
          this.sonList[i].canBudget = true;
          for (let j = 0; j < _payList.length; j++) {
            let pay = _payList[j];
            pay.budget = thousands(Number(pay.budget));
            pay.cost =
              pay.cost != "暂无" ? thousands(Number(pay.cost)) : pay.cost;
            pay.noPaidAmount = thousands(Number(pay.noPaidAmount));
            pay.paidAmount = thousands(Number(pay.paidAmount));
            pay.vendorTotalInvoice = thousands(Number(pay.vendorTotalInvoice));
            if (pay.budget_status != 1) {
              this.sonList[i].canBudget = false;
            }
          }
        }
        this.canGetNo =
          this.projectArr.contract_no == "" ||
            this.projectArr.contract_no == "TBD"
            ? true
            : false;
        this.fileList = res.itemArr.fileList
          .filter(item => item.file_type == "1")
          .map(item => {
            delete item.project_id;
            delete item.create_time;
            item.flist = [];
            return item;
          });
        this.fileList1 = res.itemArr.fileList
          .filter(item => item.file_type == "2")
          .map(item => {
            delete item.project_id;
            delete item.create_time;
            item.flist = [];
            return item;
          });
        this.fileList2 = res.itemArr.fileList
          .filter(item => item.file_type == "3")
          .map(item => {
            delete item.project_id;
            delete item.create_time;
            item.flist = [];
            return item;
          });
        //防空情况
        if (this.fileList.length === 0) {
          this.fileList = [
            { origin_name: "", file_name: "", httpFile: "", id: "", flist: [] }
          ];
        }
        if (this.fileList1.length === 0) {
          this.fileList1 = [
            { origin_name: "", file_name: "", httpFile: "", id: "", flist: [] }
          ];
        }
        if (this.fileList2.length === 0) {
          this.fileList2 = [
            { origin_name: "", file_name: "", httpFile: "", id: "", flist: [] }
          ];
        }
        this.currstatus = JSON.parse(JSON.stringify(this.projectArr.status));
        this.getDepartList(this.projectArr.manager_id);
        setTimeout(() => {
          //权限
          this.level = store.state.level;
          this.realName = store.state.realName;
        }, 200);
      });
    },
    billClick1(item) {
      if (item.applyArr) {
        if (item.applyArr?.apply_status == '0') {
          return false;
        } else {
          this.$router.push({
            path: "/apply/add",
            query: { id: item.applyArr.id, kind: 1, cid: item.project_id }
          });
        }
      } else {
        this.$router.push({
          path: "/apply/add",
          query: {
            pid: item.project_id,
            bid: item.id,
            kind: 1,
            cid: item.project_id
          }
        });
      }
    },
    billClick2(item) {
      if (!item.applyArr || item.applyArr.hope_time == "0000-00-00") {
        return false;
      } else {
        this.$router.push({
          path: "/apply/update",
          query: { id: item.applyArr.id, kind: 1, cid: item.project_id }
        });
      }
    },
    billClick3(item) {
      if (!item.applyArr) {
        this.$router.push({
          path: "/apply/pay",
          query: {
            pid: item.project_id,
            bid: item.id,
            kind: 1,
            cid: item.project_id
          }
        });
      } else {
        this.$router.push({
          path: "/apply/pay",
          query: { id: item.applyArr.id, kind: 1, cid: item.project_id }
        });
      }
    },
    billClick4(item) {
      if (!item.applyArr) {
        this.$message.error("该收款计划暂未申请开票，无法查看详情");
        return false;
      }
      this.$router.push({
        path: "/apply/view",
        query: { id: item.applyArr.id, kind: 1, cid: item.project_id }
      });
    },
    delClick(item) {
      //删除支付
      this.currDel = item;
      if (this.level != 1) {
        if (this.currDel.budget_status == "2") {
          this.$message.error("待审核的预算不可删除!");
          return false;
        }
        if (this.currDel.budget_status == "3") {
          this.$message.error("已审核的预算申请不可删除!");
          return false;
        }
      }
      this.delShow = true;
    },
    handleDel() {
      this.$fly
        .post("apiProject_delPay.html", {
          pay_id: this.currDel.id
        })
        .then(res => {
          console.log(res);
          this.delShow = false;
          this.getProjectDetail(this.query.id);
        });
    },
    editClick(item) {
      //编辑支付
      if (item.budget_status == "2") {
        this.$message.error("预算审核中!");
        return false;
      }
      for (let i = 0; i < item.planList.length; i++) {
        const element = item.planList[i].pay_check_status;
        if (element == "2") {
          this.$message.error("支付计划审核中!");
          return false;
        }
      }
      this.$router.push({
        path: "/pay/add",
        query: { id: item.id, kind: 1, cid: item.project_id }
      });
    },
    applyPayClick(item) {
      //申请支付
      const sonList = this.sonList;
      for (let i = 0; i < sonList.length; i++) {
        const element = sonList[i];
        if (element.id == item.son_project_id) {
          this.currToPay = {
            ...item,
            son_contract_name: element.contract_name
          };
        }
      }
      if (this.level != 1) {
        if (this.currToPay.budget_status != "3") {
          this.$message.error("请等待预算审核通过!");
          return false;
        }
      }
      if (!this.currToPay.vendorArr) {
        this.$message.error("请选择供应商!");
        return false;
      }
      if (this.currToPay.pay_type == "1") {
        this.currToPay.planList = this.currToPay.planList
          .map(item => {
            //只展示未申请的计划
            return item.pay_check_status == "1" ? item : "";
          })
          .filter(s => {
            return s;
          });
      }
      this.payShow = true;
      this.payForm = {
        plan_id: "",
        hope_pay_time: "",
        plan_amount: "",
        apply_amount: ""
      };
    },
    planChange() {
      this.currToPay.planList.forEach(item => {
        if (item.id == this.payForm.plan_id) {
          this.payForm = {
            ...this.payForm,
            plan_name: item.plan_name,
            apply_amount: item.plan_amount,
            plan_amount: item.plan_amount,
            hope_pay_time: item.hope_pay_time
          };
        }
      });
    },
    handleApply() {
      //提交支付申请
      for (let i = 0; i < this.currToPay.planList.length; i++) {
        const id = this.currToPay.planList[i].id;
        const status = this.currToPay.planList[i].pay_check_status;
        if (status == "2" && id == this.payForm.plan_id) {
          this.$message.error("请勿重复申请!");
          return false;
        } else if (status == "3" && id == this.payForm.plan_id) {
          this.$message.error("该支付计划审核已通过！");
          return false;
        } else if (status == "4" && id == this.payForm.plan_id) {
          this.$message.error("该支付计划审核不通过，请修改计划重新提交!");
          return false;
        }
      }
      //预支特殊情况
      if (this.currToPay.pay_type == "2" && this.payForm.plan_name == "结算") {
        console.log(this.currToPay.planList);
        if (this.currToPay.planList[0].pay_status != "3") {
          this.$message.error("请先等待预支完成支付");
          return false;
        }
      }
      this.$fly
        .post("apiProject_updatePayPlan.html", {
          ...this.payForm
        })
        .then(res => {
          console.log(res);
          this.payShow = false;
          this.getProjectDetail(this.query.id);
        });
    },
    budgetCheckClick(item) {
      //预算审核
      const sonList = this.sonList;
      for (let i = 0; i < sonList.length; i++) {
        const element = sonList[i];
        if (element.id == item.son_project_id) {
          this.currbudgetCheck = {
            ...item,
            son_contract_name: element.contract_name
          };
        }
      }
      const status = this.currbudgetCheck.budget_status;
      if (status == "1") {
        this.$message.error("本条记录还未提交审核!");
        return false;
      }
      if (this.level != 1) {
        if (status == "3" || status == "4") {
          this.$message.error("本条记录已审核!");
          return false;
        }
      }
      this.bugetCheckForm.pay_id = item.id;
      this.budgetCheckShow = true;
    },
    handleBudgetCheck() {
      // if (this.query.payId) {
      //   this.budgetCheckShow = false
      //   return false
      // }
      let temp = JSON.parse(JSON.stringify(this.bugetCheckForm));
      delete temp.pay_type;
      this.$fly
        .post("apiProject_addUpdatePay.html", {
          ...temp
        })
        .then(res => {
          console.log(res);
          this.budgetCheckShow = false;
          this.bugetCheckForm.budget_status = "4"; //还原审核状态
          this.getProjectDetail(this.query.id);
        });
    },
    payCheckClick(item) {
      //支付审核
      const sonList = this.sonList;
      for (let i = 0; i < sonList.length; i++) {
        const element = sonList[i];
        if (element.id == item.son_project_id) {
          this.currPayCheck = {
            ...item,
            son_contract_name: element.contract_name
          };
        }
      }
      if (this.level != 1) {
        if (this.currPayCheck.budget_status != "3") {
          this.$message.error("请等待预算审核通过!");
          return false;
        }
        this.currPayCheck.planList = this.currPayCheck.planList
          .map(item => {
            //只取可以审核的订单
            return item.pay_check_status == "2" ? item : "";
          })
          .filter(s => {
            return s;
          });
      }
      this.payCheckShow = true;
      this.payCheckForm = {
        plan_id: "",
        hope_pay_time: "",
        apply_amount: "",
        plan_amount: "",
        pay_check_status: "4",
        pay_check_reason: "",
        pay_check_info: ""
      };
    },
    planCheckChange() {
      this.currPayCheck.planList.forEach(item => {
        if (item.id == this.payCheckForm.plan_id) {
          this.payCheckForm = {
            ...this.payCheckForm,
            apply_amount: item.apply_amount,
            plan_amount: item.plan_amount,
            hope_pay_time: item.hope_pay_time
          };
        }
      });
    },
    handlePayCheck() {
      this.$fly
        .post("apiProject_updatePayPlan.html", {
          ...this.payCheckForm,
          apply_amount: ""
        })
        .then(res => {
          console.log(res);
          this.payCheckShow = false;
          this.payCheckForm.pay_check_status = "4"; //还原审核状态
          this.payCheckForm.pay_check_info = ""; //还原审核状态
          this.payCheckForm.pay_check_reason = ""; //还原审核状态
          this.getProjectDetail(this.query.id);
        });
    },
    addClick(item) {
      if (item.is_zero == "2") {
        return false;
      }
      this.$router.push({
        path: "/pay/add",
        query: { pid: item.project_id, sid: item.id, kind: 1 }
      });
    },
    showBudget(item) {
      if (
        !this.projectArr.contract_no ||
        this.projectArr.contract_no == "TBD"
      ) {
        this.$message.error("请先获取客户合同编号");
        return false;
      }
      if (item.is_zero == "2") {
        return false;
      }
      const sid = item.id;
      const toCheckList = [];
      for (let i = 0; i < this.sonList.length; i++) {
        const _sid = this.sonList[i].id;
        if (sid == _sid) {
          const _payList = this.sonList[i].payList;
          for (let j = 0; j < _payList.length; j++) {
            const ele = _payList[j];
            if (ele.budget_status == "1" || ele.budget_status == "0") {
              toCheckList.push(ele.id);
            }
          }
        }
      }
      if (!toCheckList.length) {
        this.$message.error("暂无需要提交审核的支付计划!");
        return false;
      }
      this.toCheckList = toCheckList;
      this.$fly
        .post("apiProject_getPayList.html", {
          pay_id_str: this.toCheckList.toString()
        })
        .then(res => {
          this.budgetPayList = res.itemList.map(item => {
            item.cost = thousands(item.cost);
            return item;
          });
          this.budgetTotal = this.toCheckList.length;
          this.budgetShow = true;
        });
    },
    handleBudget() {
      this.$fly
        .post("apiProject_submitBudget.html", {
          pay_id_str: this.toCheckList.toString()
        })
        .then(res => {
          console.log(res);
          this.budgetShow = false;
          this.getProjectDetail(this.query.id);
        });
    },
    updatePayClick(item) {
      const toCheckList = [];
      const ele = item.planList;
      for (let k = 0; k < ele.length; k++) {
        const pay_check_status = ele[k].pay_check_status;
        const eleid = ele[k].id;
        if (pay_check_status == "3") {
          toCheckList.push(eleid);
        }
      }
      if (toCheckList.length == "0") {
        this.$message.error("暂无可以更新的支付计划!");
        return false;
      }
      this.$router.push({
        path: "/project/pay",
        query: {
          id: item.id,
          cid: this.projectArr.id,
          kind: 1
        }
      });
    },
    viewClick(item) {
      this.$router.push({
        path: "/pay/view",
        query: { id: item.id, kind: 1, cid: this.projectArr.id }
      });
    },
    changeClick(item) {
      const { id, service_info, service_type } = item;
      const budget = JSON.parse(JSON.stringify(item.budget));
      this.changeForm = {
        pay_id: id,
        son_project_id: "",
        service_info,
        service_type,
        budget: antiThousands(budget)
      };
      this.changeShow = true;
    },
    changeOther() {
      return new Promise((resolve, reject) => {
        this.$fly
          .post("apiProject_addUpdatePay.html", {
            ...this.changeForm,
            option: 2
          })
          .then(res => {
            if (res.status === 200) {
              this.$message.success("支付计划已更新");
              this.changeShow = false;
              this.query.id && this.getProjectDetail(this.query.id);
              resolve(res);
            } else {
              reject("fail");
            }
          });
      });
    },
    budgetReson(item) {
      if (item.budget_status == "3") {
        this.resonShow = true;
        this.currReason.reason =
          item.budget_check_info != "" ? item.budget_check_info : "暂无";
      }
      if (item.budget_status == "4") {
        this.resonShow = true;
        this.currReason.reason =
          item.budget_check_reason != "" ? item.budget_check_reason : "暂无";
      }
    },
    payReson(item) {
      if (item.pay_check_status == "3") {
        this.resonShow = true;
        this.currReason.reason =
          item.pay_check_info != "" ? item.pay_check_info : "暂无";
      }
      if (item.pay_check_status == "4") {
        this.resonShow = true;
        this.currReason.reason =
          item.pay_check_reason != "" ? item.pay_check_reason : "暂无";
      }
    },
    handleCurrentChange(p) {
      this.p = p;
      this.getTrackList();
    },
    compDate(item) {
      return item.smartTime + "" + item.weekTime;
    },
    trigger(item) {
      let date = item.date || {};
      this.trackList = this.trackList.map(v => {
        if (v.date === date) {
          v.active = !v.active;
        }
        return v;
      });
    },
    trackChange(v) {
      this.$fly
        .post("apiProject_getTrackList.html", {
          project_id: this.query.id,
          event_id: v,
          mType: "1"
        })
        .then(res => {
          this.trackList = res.trackList;
        });
    },
    //0成本弹层
    switchShow(item) {
      if (
        !this.projectArr.contract_no ||
        this.projectArr.contract_no == "TBD"
      ) {
        this.$message.error("请先获取客户合同编号");
        return false;
      }
      if (item.payList.length != 0) {
        return false;
      } else {
        if (this.level != 1 && item.is_zero == 2) {
          return false;
        } else {
          const { contract_name, id, is_zero } = item;
          this.currCost = { contract_name, id, is_zero };
          this.costShow = true;
        }
      }
    },
    //0成本
    handleCost() {
      this.$fly
        .post("apiProject_setSonProjectZero.html", {
          son_project_id: this.currCost.id,
          is_zero: this.currCost.is_zero == 2 ? 1 : 2
        })
        .then(res => {
          console.log(res);
          this.costShow = false;
          this.currCost.is_zero = this.currCost.is_zero == 2 ? 1 : 2;
          this.sonList.forEach(item => {
            if (item.id == this.currCost.id) {
              item.is_zero = item.is_zero == 2 ? 1 : 2;
            }
          });
        });
    },
    //上传附件
    uploadFile(file, fileList, ref, item, index) {
      let formData = new FormData();
      formData.append("file_arr", file.raw);
      formData.append("type", 3);
      api
        .uploadFile(formData)
        .then(res => {
          this[fileList][index] = {
            ...item,
            origin_name: res.origin_name,
            file_name: res.file_name,
            httpFile: res.httpFile
          };
          this.$forceUpdate();
          this.$refs[ref][index].clearFiles();
        })
        .catch(err => {
          console.log(err);
        });
    },
    addImage(arr) {
      arr.push({
        origin_name: "",
        file_name: "",
        httpFile: "",
        id: "",
        flist: []
      });
    },
    removeImage(arr, index) {
      if (arr[index].id) {
        this.del_atta_list.push(arr[index].id);
      }
      console.log(this.del_atta_list);
      arr = arr.splice(index, 1);
    },
    addImage1(arr) {
      arr.push({
        origin_name: "",
        file_name: "",
        httpFile: "",
        id: "",
        flist: []
      });
    },
    removeImage1(arr, index) {
      if (arr[index].id) {
        this.del_atta_list1.push(arr[index].id);
      }
      console.log(this.del_atta_list1);
      arr = arr.splice(index, 1);
    },
    addImage2(arr) {
      arr.push({
        origin_name: "",
        file_name: "",
        httpFile: "",
        id: "",
        flist: []
      });
    },
    removeImage2(arr, index) {
      if (arr[index].id) {
        this.del_atta_list2.push(arr[index].id);
      }
      console.log(this.del_atta_list2);
      arr = arr.splice(index, 1);
    },
    //更新文件
    addUpdateProject() {
      //替换掉id为file_id
      let fileList = this.fileList.map(item => {
        delete item.flist;
        delete item.httpFile;
        item.file_type = "1";
        return item;
      });
      const fileList1 = this.fileList1.map(item => {
        delete item.flist;
        delete item.httpFile;
        item.file_type = "2";
        return item;
      });
      const fileList2 = this.fileList2.map(item => {
        delete item.flist;
        delete item.httpFile;
        item.file_type = "3";
        return item;
      });
      fileList = fileList.concat(fileList1, fileList2);
      const del_atta_list = this.del_atta_list;
      const del_atta_list1 = this.del_atta_list1;
      const del_atta_list2 = this.del_atta_list2;
      let del_atta = del_atta_list.concat(del_atta_list1, del_atta_list2);
      const $fileList = fileList.map(item => {
        Object.keys(item).forEach(key => {
          if (key == "id") {
            item["file_id"] = item[key] || 0;
            console.log(item["file_id"]);
            delete item[key];
          }
        });
        return item;
      });
      fileList = $fileList;
      this.$fly
        .post("apiProject_addUpdate.html", {
          project_id: this.query.id,
          client_id: this.projectArr.client_id,
          contract_type: this.projectArr.contract_type,
          contract_name: this.projectArr.contract_name,
          option: 2,
          client_company: this.projectArr.client_company,
          brand: this.projectArr.brand,
          contract_amount: this.projectArr.contract_amount,
          parent_project_id: this.projectArr.parent_project_id,
          info: this.projectArr.info,
          //以上内容必填
          atta_str: JSON.stringify(fileList),
          atta_del: del_atta.toString()
        })
        .then(res => {
          if (res.status === 200) {
            this.$message.success(res.message);
            this.getProjectDetail(this.query.id);
          }
        });
    },
    // setTrackId(item) {
    //   this.timeForm.track_id = item.id
    //   this.timeShow = true
    // },
    // handleTime() {
    //   this.$fly
    //     .post('apiProject_setTrackInfo.html', {
    //       ...this.timeForm
    //     })
    //     .then((res) => {
    //       console.log(res);
    //       this.timeShow = false
    //       this.getProjectDetail(this.query.id)
    //       this.timeForm = {
    //         track_id: '',
    //         create_time: '',
    //       }
    //     })
    // },
    //修改项目动态
    setTimeForm(item) {
      console.log(item);
      const { bk_uid, create_time, event_id, id, info, bkUserArr } = item;
      this.timeForm = {
        track_id: id,
        bk_uid,
        create_time,
        event_id,
        info,
        bkUserArr
      };
    },
    handleCommand(command) {
      if (command == "a") {
        this.timeForm = {
          track_id: "",
          bk_uid: "",
          create_time: "",
          event_id: "",
          info: ""
        };
        this.timeForm.option = 1;
        this.timeForm.project_id = this.projectArr.id;
        this.trackShow = true;
      } else if (command == "b") {
        delete this.timeForm.bkUserArr;
        this.timeForm.option = 2;
        this.trackShow = true;
      } else if (command == "c") {
        console.log("c");
        this.delTrackShow = true;
      }
    },
    handleTrack() {
      this.$fly
        .post("apiProject_setTrackInfo.html", {
          ...this.timeForm
        })
        .then(res => {
          console.log(res);
          this.trackShow = false;
          this.getProjectDetail(this.query.id);
        });
    },
    deleteTrack() {
      this.$fly
        .post("apiProject_delTrack.html", {
          track_id: this.timeForm.track_id
        })
        .then(() => {
          this.delTrackShow = false;
          this.getProjectDetail(this.query.id);
        });
    },
    //修改项目状态
    handleStatus() {
      this.$fly
        .post("apiProject_addUpdate.html", {
          project_id: this.query.id,
          client_id: this.projectArr.client_id,
          contract_type: this.projectArr.contract_type,
          contract_name: this.projectArr.contract_name,
          client_company: this.projectArr.client_company,
          brand: this.projectArr.brand,
          contract_amount: this.projectArr.contract_amount,
          parent_project_id: this.projectArr.parent_project_id,
          info: this.projectArr.info,
          option: 2,
          //以上内容必填
          status: this.currstatus
        })
        .then(res => {
          this.statusShow = false;
          this.$message.success(res.message);
          this.getProjectDetail(this.query.id);
        });
    },
    //报错
    showWrongFn(word) {
      this.$message.error(word);
    },
    //点击复制
    clickCopy(msg) {
      const save = function (e) {
        e.clipboardData.setData("text/plain", msg.replace(/\s*/g, ""));
        e.preventDefault(); // 阻止默认行为
      };
      const once = {
        once: true
      };
      document.addEventListener("copy", save, once); // 添加一个copy事件,当触发时执行一次,执行完删除
      document.execCommand("copy"); // 执行copy方法
      this.$message({ message: "复制成功", type: "success" });
    },
    //新增合同内容
    fillBill() {
      this.$router.push({
        path: "/project/bill",
        query: { id: this.projectArr.id }
      });
    },
    //新增收入内容
    fillContract() {
      this.$router.push({
        path: "/project/contract",
        query: { id: this.projectArr.id }
      });
    },
    //合同申请
    contractApply() {
      this.getProjectDetail(this.query.id);
      setTimeout(() => {
        if (!this.fileList[0].origin_name) {
          this.$message.error("请先上传电子合同");
          return false;
        }
        if (this.is_apply == 2) {
          this.$message.error("客户合同申请已提交");
          return false;
        }
        if (
          this.projectArr.contract_no &&
          this.projectArr.contract_no != "TBD"
        ) {
          this.$message.error("客户合同已签约，不可提交合同申请");
          return false;
        }
        this.conShow = true;
      }, 200);
    },
    handleConApply(is_apply) {
      this.$fly
        .post("apiProject_addUpdate.html", {
          project_id: this.query.id,
          client_id: this.projectArr.client_id,
          contract_type: this.projectArr.contract_type,
          contract_name: this.projectArr.contract_name,
          client_company: this.projectArr.client_company,
          brand: this.projectArr.brand,
          contract_amount: this.projectArr.contract_amount,
          parent_project_id: this.projectArr.parent_project_id,
          info: this.projectArr.info,
          option: 2,
          //以上内容必填, 2是申请，3是驳回
          is_apply: is_apply,
        })
        .then(res => {
          if (res.status === 200) {
            this.conShow = false;
            this.$message.success(res.message);
            this.getProjectDetail(this.query.id);
          }
        });
    },
    //新增子项目内容
    fillSon() {
      if (this.billList.length == 0) {
        this.$message.error("请先创建收款计划");
        return false;
      }
      this.$router.push({
        path: "/project/son",
        query: { id: this.projectArr.id }
      });
    },
    //展示供应商
    showVendor(item, _id) {
      if (!this.NodeInclude('46') || this.projectArr.is_white == '1') {
        this.$message.error("暂无权限");
        return false;
      }
      if (!_id) {
        this.$message.error("酒店差旅只能在行政项目中修改");
        return false;
      }
      const {
        id,
        project_id,
        son_project_id,
        pay_type,
        vendorArr,
        budget_status,
        planList,
        contract_id
      } = item;
      this.vendorForm = {
        pay_id: id,
        project_id,
        son_project_id,
        pay_type,
        vendor: vendorArr.vendor || "",
        vendor_id: vendorArr.id || "",
        budget_status,
        contract_id //用来判断无合同情况
      };
      if (this.level != 1) {
        if (budget_status == "2") {
          this.$message.error("预算审核中不可更改供应商");
          return false;
        }
        let flag = false;
        if (planList) {
          planList.forEach(it => {
            if (it.pay_check_status == "3") {
              return (flag = true);
            }
          });
        }
        if (flag) {
          this.$message.error("支付审核通过后不可修改供应商");
          return false;
        }
      }
      this.vendorShow = true;
      this.getVendorList(pay_type);
    },
    vendorChange(v) {
      this.vendorList.forEach(item => {
        if (item.id == v) {
          this.vendorForm = {
            ...this.vendorForm,
            vendor_id: item.id,
            vendor: item.vendor,
            contract_id:
              this.vendorForm.contract_id === "-1"
                ? this.vendorForm.contract_id
                : ""
          };
        }
      });
      const tempForm = JSON.parse(JSON.stringify(this.vendorForm));
      delete tempForm.budget_status;
      delete tempForm.pay_type;
      delete tempForm.vendor;
      this.updatePayVendor(tempForm).then(res => {
        console.log(res);
        this.vendorShow = false;
      });
    },
    getVendorList(pay_type) {
      this.$fly
        .post("apiPurchase_getVendorList.html", {
          per_page: 5000,
          type: pay_type == "2" ? "2" : "" //预支只能是个人
        })
        .then(res => {
          this.vendorList =
            pay_type == "2"
              ? res.itemList.filter(item => item.is_staff == "1")
              : res.itemList;
        });
    },
    //展示下载列表
    showNewVendor() {
      this.vendorShow = false;
      this.newVendorShow = true;
    },
    //展示供应商合同
    showPurchase(item, _id) {
      if (!this.NodeInclude('46') || this.projectArr.is_white == '1') {
        this.$message.error("暂无权限");
        return false;
      }
      if (!_id) {
        this.$message.error("酒店差旅只能在行政项目中修改");
        return false;
      }
      const {
        id,
        project_id,
        son_project_id,
        pay_type,
        budget,
        vendorArr,
        budget_status,
        vendorContractArr,
        planList
      } = item;
      this.vendorForm = {
        pay_id: id,
        project_id,
        son_project_id,
        pay_type,
        budget,
        vendor: vendorArr.vendor || "",
        vendor_id: vendorArr.id || "",
        budget_status,
        client_contract_name: this.projectArr.contract_name,
        contract_id: vendorContractArr.id || ""
      };
      if (this.level != 1) {
        if (
          vendorContractArr.contract_no &&
          vendorContractArr.contract_no != "TBD"
        ) {
          if (this.level != 1) {
            this.$message.error("已获取编号的合同不能更改");
            return false;
          }
        }
        if (budget_status == "2") {
          this.$message.error("预算审核中不可更改供应商");
          return false;
        }
        let flag = false;
        if (planList) {
          planList.forEach(it => {
            if (it.pay_check_status == "3") {
              return (flag = true);
            }
          });
        }
        if (flag && this.vendorForm.contract_id) {
          this.$message.error("支付审核通过后不可修改供应商合同");
          return false;
        }
      }
      this.purchaseShow = true;
      this.getPurchaseList(this.vendorForm);
    },
    getPurchaseList(postData) {
      const { client_contract_name } = postData;
      this.$fly
        .post("apiPurchase_getContractList.html", {
          per_page: 5000,
          client_contract_name
        })
        .then(res => {
          this.purchaseList = res.itemList;
        });
    },
    addPurchase(item) {
      this.$router.push({
        path: "/purchase/add",
        query: {
          pid: item.project_id,
          vid: item.vendor_id,
          kind: 1,
          payid: item.pay_id, //更新支付计划合同选择
          mType: "1"
        }
      });
    },
    purchaseChange(v) {
      this.purchaseList.forEach(item => {
        if (item.id == v) {
          this.vendorForm = {
            ...this.vendorForm,
            vendor: item.vendor,
            vendor_id: item.vendor_id,
            contract_id: item.id,
            contract_amount: item.contract_amount,
            vendor_type: item.vendor_type,
            contract_no: item.contract_no
          };
        }
      });
      if (
        this.vendorForm.pay_type == "2" &&
        this.vendorForm.is_staff != "1" &&
        this.vendorForm.vendor_type == "1"
      ) {
        console.log(this.vendorForm.pay_type, this.vendorForm.vendor_type);
        this.$message.error(`预支只能选择个人供应商`);
        this.purchaseShow = false;
        return false;
      }
      if (
        antiThousands(this.vendorForm.contract_amount) -
        antiThousands(this.vendorForm.budget) >
        0
      ) {
        this.$message.error(`合同金额不能大于预算`);
        this.purchaseShow = false;
        return false;
      }
      const tempForm = JSON.parse(JSON.stringify(this.vendorForm));
      delete tempForm.budget_status;
      delete tempForm.pay_type;
      delete tempForm.project_id;
      delete tempForm.budget;
      delete tempForm.is_staff;
      delete tempForm.contract_amount;
      delete tempForm.vendor_type;
      delete tempForm.contract_no;
      this.updatePayVendor(tempForm).then(res => {
        console.log(res);
        this.purchaseShow = false;
      });
    },
    //更新支付计划的供应商
    updatePayVendor(tempForm) {
      return new Promise((resolve, reject) => {
        this.$fly
          .post("apiProject_addUpdatePay.html", {
            ...tempForm,
            option: 2
          })
          .then(res => {
            if (res.status === 200) {
              this.$message.success("支付计划已更新");
              this.query.id && this.getProjectDetail(this.query.id);
              resolve(res);
            } else {
              reject("fail");
            }
          });
      });
    },
    handleHandover() {
      this.$fly
        .post("apiProject_modifyProjectLeader.html", {
          project_id: this.query.id,
          user_id: this.handoverForm.user_id
        })
        .then(res => {
          if (res.status === 200) {
            this.handoverShow = false;
            this.handoverForm.user_id = "";
            this.$message.success(res.message);
            this.getProjectDetail(this.query.id);
          }
        });
    },
    getSelectType(vid, cid) {
      const that = this;
      return new Promise(function (resolve) {
        that.$fly.post("ApiVendorCard_selectTypeList.html", {
          vendor_id: vid,
          cate_id: cid
        }).then((res) => {
          const selectTypeList = res.length ? res : [];
          resolve(selectTypeList)
        });
      })
    },
    getCardInfoToVendorAndCate(vid, cid, desc) {
      const that = this;
      return new Promise(function (resolve) {
        that.$fly.post("ApiVendorCard_getCardInfoToVendorAndCate.html", {
          vendor_id: vid,
          cate_id: cid,
          card_desc: desc,
        }).then((res) => {
          const cardInfo = res
          resolve(cardInfo)
        });
      })
    },
    checkClick(scope) {
      this.checkLay = true
      this.getVendorList()
      this.checklayForm = {}
      const $c = this.checklayForm
      $c.vendor_id = scope.vendorArr?.id
      this.changeData($c.vendor_id, 'vVendor')
    },
    changeData(value, ref) {
      const form = this.checklayForm
      if (ref == 'vVendor') {
        this.getSelectType(value).then(res => {
          if (res.length) {
            //有对应列表
            this.$set(form, `selectTypeList`, res);
          }
          else {
            //没有对应列表，针对老数据
            this.getSelectType().then(res => {
              this.$set(form, `selectTypeList`, res);//把全列表展示出来
            })
          }
        })
      }
      if (ref == 'cateIdArray') {
        const trueId = value[value.length - 1]
        this.$set(form, `cate_id`, trueId);
        this.getSelectType(form.vendor_id, trueId).then(res => {
          this.$set(form, `descList`, res)
        })
      }
      if (ref == 'cardDesc') {
        this.getCardInfoToVendorAndCate(form.vendor_id, form.cate_id, value).then(res => {
          this.$set(form, `price`, res.price)
          this.$set(form, `unit`, res.unit)
          this.$set(form, `card_desc`, res.card_desc)
          this.$set(form, `cateInfo`, res.cateInfo)
          // this.$set(row, `number`, 1)
        })
      }
    },
    goCheck() {
      const { vendor_id, cate_id, card_desc, price, unit, cateInfo } = this.checklayForm
      if (!cateInfo) {
        this.$message.error("请选择具体刊例");
        return false
      }
      let newItem = { vendor_id, cate_id, cate_id_array: JSON.parse(cateInfo.cate_id_json), card_desc, price, unit, number: 1, }
      this.getSelectType(vendor_id).then(res => {
        newItem.selectTypeList = res
        store.commit('setSimData', JSON.parse(JSON.stringify(newItem)))
        this.$router.push({
          path: '/pubcase/sim',
          query: {},
        })
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.header {
  //标题样式
  @extend %box;
  box-sizing: border-box;
  width: 100%;
  background: #fff;
  padding: 20px 40px;
  margin-bottom: 10px;
  @extend %center;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: flex-start;

  .header-info {
    width: 80%;
    @extend %center;
    align-items: flex-start;
    text-align: left;

    h1 {
      font: 700 28px/1 $font;
      margin-bottom: 16px;
    }

    p {
      font: 16px/2 $font;
    }
  }

  .header-status {
    @extend %center;
    flex-flow: row nowrap;

    .button {
      box-sizing: border-box;
      min-width: 100px;
      border-radius: 20px;
      padding: 10px 15px;
      font: 12px/1 $font;
      color: #fff;
    }
  }
}

.userdetail {
  .history {
    @extend %box;
    padding: 30px 40px;
  }

  .base1 {
    @extend %box;
    margin-bottom: 20px;
    padding: 30px 40px;
    position: relative;

    ul {
      @extend %start;
      color: #231f20;
      background: #f2f2f2;
      padding: 0 25px;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;

      &:last-of-type {
        margin-bottom: 0;
      }

      li {
        width: 50%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          padding: 5px 0;
          @extend %start;
          position: relative;

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }

          .projectArrBtnArea {
            width: 180px;
            position: absolute;
            left: 60%;
            @extend %start;
            z-index: 1;
            .projectArrBtn {
              margin-right: 20px;
              &:last-of-type {
                margin-right: 0;
              }
            }
          }
        }
      }
    }
  }

  .table {
    @extend %box;
    padding: 20px 40px;
    margin-bottom: 20px;
    position: relative;

    ul {
      @extend %start;
      color: #231f20;
      background: #fff;
      padding: 0 25px;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;

      &:last-of-type {
        margin-bottom: 0;
      }

      li {
        width: 40%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          @extend %start;

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }
        }

        &:last-child {
          width: 60%;
          box-sizing: border-box;
          padding-left: 85px;
        }
      }
    }

    .for-title {
      font: 700 24px/1.5 $font;
      color: #444041;
    }

    .for {
      padding: 25px 0;

      &.grey {
        padding: 25px 20px;
        border-radius: 20px;
        background: #f2f2f2;
        margin-bottom: 20px;
      }

      ul {
        @extend %start;
        color: #231f20;
        background: #f2f2f2;
        padding: 0 25px;
        border-radius: 20px;
        margin-bottom: 20px;
        position: relative;

        &:last-of-type {
          margin-bottom: 0;
        }

        li {
          width: 40%;
          font: 14px/3 $font;

          p {
            height: 42px;
            @extend %start;

            label {
              width: 150px;
              white-space: nowrap;
              flex: none;
            }

            span {
              white-space: nowrap;
            }
          }

          &:last-child {
            width: 60%;
            box-sizing: border-box;
            padding-left: 85px;
          }
        }
      }

      .el-button {
        float: right;
        margin-bottom: 10px;
        position: relative;
      }
    }
  }

  .form {
    padding: 30px;
    margin-bottom: 0;
    box-shadow: none;
    border-radius: 20px;
    background: #f2f2f2;

    .anlist {
      padding: 0;
      flex-flow: column nowrap;

      li {
        position: relative;
        padding: 0;

        &:last-of-type {
          padding-left: 0;
          width: 60%;
        }

        .abtn {
          position: absolute;
          top: 0;
          left: 80%;
        }

        .bbtn {
          position: absolute;
          top: 0;
          left: 80%;
        }
      }
    }
  }
}

.linkwrap {
  font-size: 12px;

  &.normal {
    color: #606266;

    a {
      color: #606266;

      &:hover {
        &::after {
          height: 0.2px;
          background-color: #606266;
        }
      }

      >span {
        font-size: 12px;
        color: #606266;
      }
    }
  }

  &.grey {
    color: #999;
  }
}

.aul.ulist {
  min-height: 480px;
  padding: 20px 0;
  font: 14px/2 $font;
  text-align: left;

  >li {
    padding: 0 60px;
    display: flex;
    flex-flow: row nowrap;

    span {
      display: inline-block;
      width: 50%;
    }
  }

  .ulform {
    padding: 0 60px;
  }

  .el-form-item--small.el-form-item {
    margin-bottom: 0;
  }
}

.flex-box1,
.right {
  @extend %start;
  justify-content: space-between;
  align-items: center;

  .left {
    width: 80%;
  }

  .right {
    width: 20%;
    justify-content: flex-end;
  }
}

.switch {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}

.el-switch {
  font: 14px/20px $font;

  &.cursor {
    cursor: not-allowed;

    .el-switch__core {
      background-color: #999888;
      border-color: #999888;
      cursor: not-allowed;
    }
  }

  &.is-checked {
    cursor: not-allowed;

    .el-switch__core {
      cursor: not-allowed;
      background-color: #999888;
      border-color: #999888;

      &::before {
        font: 14px/20px $font;
        content: "是";
      }
    }
  }

  .el-switch__core {
    background-color: #0e0f22;
    border-color: #0e0f22;

    &::before {
      font: 14px/20px $font;
      content: "否";
    }

    &::after {
      content: "";
    }
  }
}

.info-height {
  display: inline-block;
  // box-sizing: border-box;
  padding: 0px 5px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  max-height: 40px;
  overflow-x: hidden;
  //隐藏水平滚动条
  overflow-y: scroll;

  //隐藏垂直滚动条
  &::-webkit-scrollbar {
    width: 2px;
  }

  &::-webkit-scrollbar-track {
    background-color: rgba(0, 0, 0, 0.1);
  }

  /* 滚动条的滑轨背景颜色 */
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.5);
  }

  /* 滑块颜色 */
}

.inblank {
  @extend %center;
  font: 14px/2 $font;
  color: #999;
  background: #f2f2f2;
  padding: 25px;
  border-radius: 20px;
  margin-bottom: 20px;
  position: relative;
}

.operater {
  @extend %start;
  position: absolute;
  top: 30px;
  right: 40px;
  font: 14px/1 $font;
  text-align: center;

  >div {
    min-width: 32px;
    border: 1px solid #dcdfe6;
    border-radius: 3px;
    padding: 9px 10px;
    cursor: pointer;

    &.linkline {
      border-color: transparent;
      background: transparent;
      color: #231f20;

      &:hover {
        &::after {
          display: block;
          content: "";
          height: 0.1px;
          background: #231f20;
        }
      }
    }

    &.linkbox {
      border-color: #0e0f22;
      background: #0e0f22;
      color: #fff;

      &.grey {
        border-color: #c0c4cc;
        background: #c0c4cc;
        color: #fff !important;

        &:hover {
          background: #c0c4cc;
        }
      }

      &:hover {
        background: rgba($color: #0e0f22, $alpha: 0.8);
      }
    }
  }
}

.dialog-download {
  border-radius: 12px;
  background: #231f20;
  font: 12px/2 $font;
  color: #fff;
  padding: 5px 20px;
  margin: 0 20px;

  &:hover {
    color: #fff;
    background: rgba($color: #0e0f22, $alpha: 0.8);

    &::after {
      display: none;
    }
  }
}
</style>

<style lang="scss">
.linehead {
  //时间版头样式
  display: flex;
  flex-flow: row nowrap;
  font: 16px/1 $font;
  color: $c;
  padding: 25px 55px 0 60px;

  li {
    flex: auto;

    &:nth-child(1) {
      width: 190px;
      flex: none;
    }

    &:nth-child(2) {
      width: 190px;
      flex: none;
    }

    &:nth-child(3) {
      width: 190px;
      flex: none;
    }

    &:nth-child(4) {
      width: 880px;
      flex: none;
    }
  }
}

.timeline {
  //时间版内样式
  margin: 20px 25px 20px 30px;
  padding: 50px 30px;
  border-radius: 6px;
  border: solid 1px #bfbfbf;

  .ico-edit {
    display: block;
    width: 20px;
    height: 20px;
    z-index: 999 !important;
    position: absolute;
    left: -160px;
    top: 0px;
    cursor: pointer;

    ::before {
      font-size: 20px;
      width: 20px;
      height: 20px;
    }
  }

  .mycard {
    min-height: 80px;
    background-color: #f5f5f5;
    border-radius: 4px;
    padding: 0 20px;
    position: relative;
    transform: translateY(-20px);
    // pointer-events: none;

    &.parent {
      pointer-events: auto;
      // cursor: pointer;
    }

    &.active {
      background-color: #fff;
      height: 30px;

      &:before {
        display: none;
      }

      dl,
      .point {
        display: none;
      }
    }

    &:before {
      content: "";
      font-size: 0;
      border-bottom: 20px solid #f5f5f5;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 10px solid transparent;
      position: absolute;
      top: 0;
      left: -10px;
    }

    dl {
      flex: none;
      display: flex;
      height: 80px;
      flex-flow: column wrap;
      padding: 10px 60px 10px 00px;
      flex-flow: row nowrap;

      dd {
        height: 60px;
        width: 150px;

        &:nth-child(2) {
          width: 180px;
        }

        flex: none;
        display: flex;
        flex-flow: column nowrap;
        align-items: flex-start;
        justify-content: center;

        span {
          font: 14px/30px $font;
        }
      }
    }

    .ul {
      padding: 0;
      display: flex;
      flex-flow: row nowrap;
      position: relative;
      z-index: 999;

      li {
        @extend %center;
        align-items: flex-start;
        min-height: 80px;
        flex: auto;
        font: 14px/20px $font;

        &:nth-child(1) {
          width: 180px;
          flex: none;
        }

        &:nth-child(2) {
          width: 180px;
          flex: none;
        }

        &:nth-child(3) {
          padding-left: 20px;
          display: flex;
          flex-flow: column nowrap;
          padding: 10px 60px 10px 20px;
          box-sizing: border-box;
          text-align: left;

          span {
            font: 14px/30px $font;

            &.grey {
              font-size: 14px;
              color: #999;
            }
          }

          a {
            display: inline-block;
            position: relative;
            z-index: 999999999999999999 !important;
            cursor: pointer;
          }
        }
      }
    }

    .point {
      position: absolute;
      background: $c;
      color: #fff;
      height: 30px;
      font: 16px/30px $font;
      padding: 0 10px;
      border-radius: 15px;
      right: 30px;
      top: 25px;
    }

    .ticon {
      position: absolute;
      left: -160px;
      height: 30px;
      line-height: 30px;
      padding: 0 20px 0 88px;
      color: #fff;
      top: 14px;
    }
  }

  .el-timeline {
    padding-left: 140px;

    .el-timeline-item {
      position: relative;
    }
  }

  .child {
    .el-timeline-item__timestamp.is-top {
      background-color: #ffffff;
      color: #9c9a9a;
      text-align: right;
    }
  }

  .el-timeline-item__timestamp.is-top {
    position: absolute;
    left: -140px;
    width: 120px;
    height: 30px;
    background-color: #2696d2;
    border-radius: 4px;
    color: #fff;
    font: 14px/30px $font;
    padding: 0 0 0 10px;
    top: -6px;
    box-sizing: border-box;
  }
}
</style>
